import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import HeaderTop from './HeaderTop';
import HeaderNav from './HeaderNav';
import Banner from './Banner';
import Breadcrumbs from './Breadcrumbs'


interface IProps {
}

const Component: NextPage<IProps> = ({}) => {
  const Router = useRouter()
  const [isBannerShow, setIsBannerShow] = useState(false);
  const [isBreadcrumbsShow, setIsBreadcrumbsShow] = useState(false);

  useEffect(() => {
    let _isBannerShow = false;
    let _isBreadcrumbsShow = false;
    if (Router.pathname !== '/') {
      _isBannerShow = true;
      _isBreadcrumbsShow = true;
    }
    setIsBannerShow(_isBannerShow);
    setIsBreadcrumbsShow(_isBreadcrumbsShow);
  }, [Router.pathname])

  return (
    <div className='flex flex-col'>
      <HeaderTop />
      <HeaderNav />
      {isBannerShow && <Banner />}
      {isBreadcrumbsShow && <Breadcrumbs />}
    </div>
  )
}

export default Component
